import { ReportFragment } from '../../../../models';

const isRemoveRowAttributeName = (value: ReportFragment) => value.name === ' Remove Row ';

export default isRemoveRowAttributeName;
